import getApi from '../../api'
import { Drug, DrugIdentity } from '../../model/Drug'

export const getDrug = ({ id, type }: DrugIdentity, signal?: AbortSignal) => {
  return getApi().get<Drug>(`drugs/info`, { id, type }, { signal })
}
